import { Typography } from "@mui/material"
import { visuallyHidden } from "@mui/utils"
import { useIsDesktop } from "common/MediaQueries"
import ModelTitleAndImage from "common/ModelTitleAndImage"
import { useLayoutContext } from "layout/oldLayout/LayoutContext"
import styled from "styled-components"
import SelectedDetailingDetails from "../detailing/SelectedDetailingDetails"
import { ShopFooter } from "../wizard/ShopFooter"
import LegalNotes from "./LegalNotes"
import ShareButton from "./ShareButton"
import SummaryGallery from "./SummaryGallery"
import SummarySidebar from "./SummarySidebar"

const StyledLegalNotes = styled(LegalNotes)`
  margin: 0 0 40px 0;
`

const StyledShareContainer = styled.div`
  position: relative;
  direction: ltr !important;
`

const StyledShareButton = styled(ShareButton)`
  position: absolute;
  top: 15px;

  direction: rtl;
`

const StyledSummaryGallery = styled(SummaryGallery)`
  margin-bottom: 20px;
`

const SummaryPage = () => {
  const isDesktop = useIsDesktop()
  const { isShowRoomsScreens } = useLayoutContext()
  return (
    <>
      <Typography sx={visuallyHidden} component={"h1"}>
        סיכום
      </Typography>
      {!isShowRoomsScreens && (
        <StyledShareContainer>
          <StyledShareButton />
        </StyledShareContainer>
      )}
      <ModelTitleAndImage />
      {!isDesktop && <SummarySidebar />}
      <StyledSummaryGallery />
      <SelectedDetailingDetails hasBackground={true} />
      <StyledLegalNotes />
      <ShopFooter hidePrice />
    </>
  )
}

export default SummaryPage
